import React from 'react';
import Rating from 'react-rating';

const Star = props => {
  return props.full ? (
    <img src={require('./star-full.svg')} alt="Star Full" width="100%" />
  ) : (
    <img src={require('./star-empty.svg')} alt="Star Empty" width="100%" />
  );
};

const StarRating = props => {
  return (
    <Rating
      emptySymbol={<Star />}
      fullSymbol={<Star full />}
      readonly={props.readonly}
      initialRating={props.initialRating}
      onChange={props.onChange}
    />
  );
};

export default StarRating;
